import { gql, useMutation } from '@apollo/client';
import { callSideEffects } from '../../util';
import { currentRoomsVar } from './currentRooms';
import { selectRoomMetric } from './selectRoomMetric';
const SELECT_ROOMS_MUTATION = gql `
    mutation SelectRooms($request: SelectRoomsRequest!) {
        selectRooms(request: $request) {
            basket {
                hotelProducts {
                    lineItems {
                        description
                        typeId
                        unitAmount
                        unitAmountFormatted
                        quantity
                    }
                    itinerary {
                        ... on BasketHotelItinerary {
                            mandatoryExtras {
                                title
                                options {
                                    hotelExtraOptionId
                                    customerText
                                }
                                hotelExtraTypeId
                                hotelExtraId
                            }
                        }
                    }
                }
            }
            tripStateId
            tripType
            searchParameters {
                tripStateId
                tripType
            }
        }
    }
`;
export function useRooms(onCompleted, onError) {
    const [selectRoomsMutation, selectRoomsState] = useMutation(SELECT_ROOMS_MUTATION, {
        onError: (err, operation) => {
            var _a, _b;
            if (onError === null || onError === void 0 ? void 0 : onError.length)
                callSideEffects(onError, err);
            selectRoomMetric(((_a = operation === null || operation === void 0 ? void 0 : operation.variables) === null || _a === void 0 ? void 0 : _a.request.tripStateId) || 'no trip Id', err.graphQLErrors);
            currentRoomsVar(Object.assign(Object.assign({}, currentRoomsVar()), {
                rooms: (_b = currentRoomsVar().rooms) === null || _b === void 0 ? void 0 : _b.map((el) => (Object.assign(Object.assign({}, el), { isConfirmed: false }))),
                soldOut: true,
                selectedRoomIndex: 0,
            }));
        },
        onQueryUpdated: (observableQuery) => {
            console.log('observable query', observableQuery);
            // TODO: put the logic here to check for tripType and go for a fetch if hotel only
            // True: refetch observed query, false: ignore query
            // it will be called for each affected query and surely for query in refetchQueries array
            return true;
        },
        onCompleted: (mutationData) => {
            var _a;
            selectRoomMetric(((_a = mutationData.selectRooms) === null || _a === void 0 ? void 0 : _a.tripStateId) || 'no trip Id');
            if (mutationData === null || mutationData === void 0 ? void 0 : mutationData.selectRooms) {
                callSideEffects(onCompleted, mutationData.selectRooms);
            }
        },
    });
    const selectRooms = (request) => {
        selectRoomsMutation({
            variables: { request },
        });
    };
    return { selectRooms, selectRoomsState };
}
